import { SelfRegCouponMainPageProps } from 'src/pages/SelfRegCouponPage/SelfRegCouponMainPage/index'
import { Container } from 'src/components/common/Container'
import styled from 'styled-components'
import React from 'react'
import { Divider, MiddleDivider, SmallDivider } from 'src/components/common/Divider'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import { Spinner } from 'src/components/common/Spinner'
import { Noto_subheading_r18 } from 'src/styles/fonts/NotoSansKrFonts'
import { Typography } from 'src/components/common/Typography'
import useLoginDetectorHook from 'src/hooks/useLoginDetector.hook'
import { layoutMaxSize } from 'src/styles/mixin'
import SelfRegisterCard from 'src/pages/SelfRegCouponPage/SelfRegCouponMainPage/_components/SelfRegisterCard'
import RenderIf from 'src/components/common/RenderIf'

const SelfRegCouponMainPageView = ({
  selfRegisterCouponNoMore,
  selfRegisterCouponListData,
  selfRegisterUpdatePageNav,
  selfRegisterCreatePageNav,
  selfRegisterCouponDeleteHandler,
  setTarget,
}: SelfRegCouponMainPageProps) => {
  const { isLogin } = useLoginDetectorHook()
  return (
    <S.SelfRegCouponContainer $option="flex_column_space_between">
      {selfRegisterCouponListData?.length === 0 ? (
        <S.IsNotSelfCouponWrap $option="flex_column">
          <Typography $fontStyle={Noto_subheading_r18} $color="var(--black-30)">
            보유한 쿠폰이 없습니다.
          </Typography>
        </S.IsNotSelfCouponWrap>
      ) : (
        <S.IsSelfCouponWrap $option="flex_column_space_between">
          <MiddleDivider />
          <S.SelfCardWrap $option="flex_column">
            {selfRegisterCouponListData?.map((couponInfo, index: number) => (
              <Container $option="flex_column" key={couponInfo?.Idx}>
                <RenderIf when={index !== 0}>
                  <Divider />
                </RenderIf>
                <SelfRegisterCard
                  {...couponInfo}
                  selfRegisterUpdatePageNav={selfRegisterUpdatePageNav}
                  selfRegisterCouponDeleteHandler={selfRegisterCouponDeleteHandler}
                />
              </Container>
            ))}
            <RenderIf when={!selfRegisterCouponNoMore}>
              <Spinner $color="var(--black-10)" ref={setTarget} $margin="50px auto" />
            </RenderIf>
          </S.SelfCardWrap>
          <MiddleDivider />
        </S.IsSelfCouponWrap>
      )}
      <SmallDivider />
      <S.SelfRegBottomContents $option="flex_column">
        <Button
          option={ButtonOption3('active')}
          disabled={!isLogin}
          onClickFn={selfRegisterCreatePageNav}
        >
          쿠폰등록
        </Button>
      </S.SelfRegBottomContents>
    </S.SelfRegCouponContainer>
  )
}
export default SelfRegCouponMainPageView

const S = {
  SelfRegCouponContainer: styled(Container)`
    flex: 1;
    padding-bottom: 68px;
  `,
  IsNotSelfCouponWrap: styled(Container)`
    flex: 1;
    align-items: center;
    justify-content: center;
  `,
  IsSelfCouponWrap: styled(Container)`
    flex: 1;
  `,
  SelfCardWrap: styled(Container)`
    flex: 1;
    justify-content: flex-start;
  `,
  SelfRegBottomContents: styled(Container)`
    ${layoutMaxSize};
    gap: 10px;
    padding: 10px;
    position: fixed;
    bottom: 0;
    background-color: var(--white);
    z-index: 2;
  `,
}
